import axios from 'axios';

export default async function createRow(
  ENVIRONMENT,
  userToken,
  dataTableId,
  email,
  tokenGodMode
) {
  try {
    const response = await axios.post(
      'https://tokenonco.kdash.com.br/api/datatable',
      {
        ENVIRONMENT,
        userToken,
        dataTableId,
        email,
        tokenGodMode,
      }
    );

    console.log('Resposta:', response.data);
  } catch (error) {
    console.error('Erro:', error.response?.data || error.message);
  }
}
